/**
 * Mesma lógica de AwarenessStageTable: lista plana id/id_pai → árvore ordenada.
 * Normaliza id/id_pai (string vs number vs BigInt do MySQL) para o Map não quebrar.
 */
function normId(v) {
  if (v == null || v === "") return null;
  const n = typeof v === "bigint" ? Number(v) : Number(v);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function buildAwarenessGroupTree(items = []) {
  const byId = new Map();
  items.forEach((it) => {
    const id = normId(it.id);
    if (id == null) return;
    byId.set(id, { ...it, id, children: [] });
  });
  const roots = [];
  byId.forEach((node) => {
    const p = normId(node.id_pai);
    if (p != null && byId.has(p)) {
      byId.get(p).children.push(node);
    } else {
      roots.push(node);
    }
  });
  const sortRec = (arr) => {
    arr.sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
    arr.forEach((n) => sortRec(n.children || []));
    return arr;
  };
  return sortRec(roots);
}

function sameProjectId(rowProjeto, targetPid) {
  const a = rowProjeto == null ? "" : String(rowProjeto).trim();
  const b = String(targetPid).trim();
  if (a === b) return true;
  const na = Number(a);
  const nb = Number(b);
  return Number.isFinite(na) && Number.isFinite(nb) && na === nb;
}

/**
 * Etapas de consciência no setup: mesma visão da tela /awareness-stages (raízes da árvore),
 * apenas do id_projeto atual.
 */
export function awarenessSetupLevelsFromGroups(groups, idProjeto) {
  const pid = Number(idProjeto);
  if (!Number.isFinite(pid) || pid <= 0) return [];
  const all = (Array.isArray(groups) ? groups : []).filter((g) => Number(g.excluido) !== 1);
  let flat = all.filter((g) => sameProjectId(g.id_projeto, pid));
  // Mesmo comportamento da tabela em /awareness-stages: usa o payload já filtrado pela API;
  // se não houver linhas para este id_projeto mas a lista veio preenchida (legado), monta a árvore com tudo.
  if (!flat.length && all.length) {
    const distinct = new Set(all.map((g) => Number(g.id_projeto)));
    if (distinct.size === 1) flat = all;
  }
  if (!flat.length) return [];
  const roots = buildAwarenessGroupTree(flat);
  return roots
    .map((r) => ({
      title: String(r.nome || "").trim(),
      description: "",
    }))
    .filter((x) => x.title);
}
